<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">{{isCreate ? 'Add Language' : 'Edit Language'}}</h2>
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="#" @click="$router.go(-1)">Back</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{isCreate ? 'Add Language' : 'Edit Language'}}</li>
        </ol>
      </div>
      <div class="d-flex">
      </div>
    </div>
    <div class="row row-sm justify-content-center">
      <div class="col-xl-7 col-md-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Language</h6>
            </div>
            <div v-if="languages && languages.length">
              <ValidationObserver ref="languageAddForm" id="addLanguageForm" tag="form" class="d-flex flex-column" @submit.prevent="formSubmit()">
                <b-tabs content-class="mt-3">
                  <b-tab :title="language.code" v-for="(language, i) in languages" :key="i">
                    <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                      <label :for="'title[' + language.code + ']'" class="form-label">Title:</label>
                      <input :id="'title[' + language.code + ']'" class="form-control" :name="'title_l[' + language.code + ']'" v-model="formData.title_l[language.code]" :class="checkValidation(classes, language.code)" placeholder="title" type="text">
                    </ValidationProvider>
                  </b-tab>
                  <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                    <label for="type" class="form-label">Type:</label>
                    <select id="type" class="form-control" v-model="formData.type" name="type" :class="classes">
                      <option value="rtl">RTL</option>
                      <option value="ltl">LTL</option>
                    </select>
                  </ValidationProvider>
                  <ValidationProvider v-slot="{ classes }" rules="required" tag="div" class="form-group">
                    <label for="code" class="form-label">Code:</label>
                    <input id="code" class="form-control" v-model="formData.code" name="code" :class="classes" placeholder="code" type="text">
                  </ValidationProvider>
                  <ValidationProvider tag="div" v-slot="{ classes }" class="form-group">
                    <label for="continent_id" class="form-label">Countries:</label>
                    <multiselect v-model="formData.countries" placeholder="Select countries" id="continent_id" :multiple="true" :custom-label="customLabel" :class="classes"  :close-on-select="true" track-by="id" :options="countries">
                      <template slot="singleLabel" slot-scope="props">
                        {{props.option.title_l[$i18n.locale]}}
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__name">{{props.option.title_l[$i18n.locale]}}</span>
                      </template>
                    </multiselect>
                  </ValidationProvider>
                  <ImageUpload accept="image/*" label="Image:" name="flag" uploadType="oneImage" type="image" :filesData="[formData.flag]" />
                  <div class="form-group">
                    <label for="localizationJson" class="form-label">Localization:</label>
                    <v-jsoneditor id="localizationJson" v-model="formData.localization_json" :options="options" name="localization_json" :plus="true" height="400px"/>
                  </div>
                </b-tabs>
                <button class="btn ripple btn-main-primary">Submit</button>
              </ValidationObserver>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import VJsoneditor from 'v-jsoneditor/src/index'
import ImageUpload from '../../components/ImageUpload'

export default {
  name: 'AddLanguage',
  data () {
    return {
      countries: [],
      formData: {
        type: 'rtl',
        code: '',
        title_l: {},
        countries: [],
        uploadedFiles: '',
        localization_json: {}
      },
      options: {
        mode: 'code'
      },
      isCreate: false,
      languageId: null
    }
  },
  components: {
    ImageUpload,
    VJsoneditor
  },
  computed: {
    ...mapState({
      languages: state => state.language.languages
    })
  },
  created () {
    this.languageId = this.$route.params.id
    if (this.languageId === 'add') {
      this.isCreate = true
      this.getJson()
    } else {
      this.getLanguage(this.languageId).then(res => {
        this.formData = res.data
      })
    }
    this.getCreateData().then((res) => {
      this.countries = res.data.countries
    })
  },
  methods: {
    ...mapActions({
      createLanguage: 'language/createLanguage',
      updateLanguage: 'language/updateLanguage',
      getLanguage: 'language/getLanguage',
      getCreateData: 'language/getCreateData',
      getJsonFile: 'language/getJsonFile'
    }),
    customLabel (data) {
      return `${data.title_l[this.$i18n.locale]}`
    },
    getJson () {
      this.getJsonFile().then(res => {
        this.formData.localization_json = res
      })
    },
    checkValidation (data) {
      return data
    },
    formSubmit () {
      this.$refs.languageAddForm.validate().then(success => {
        if (success) {
          const form = document.getElementById('addLanguageForm')
          const formData = new FormData(form)
          this.formData.countries.map((item) => {
            formData.append('countries[]', item.id)
          })
          formData.append('localization_json', JSON.stringify(this.formData.localization_json))
          if (this.isCreate) {
            this.createLanguage(formData).then(() => {
              this.$router.push('/language')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            })
          } else {
            this.updateLanguage({ data: formData, id: this.languageId }).then(() => {
              this.$router.push('/language')
            }).catch(err => {
              if (err && err.response) {
                if (err.response.status === 422) {
                  const data = err.response.data.errors
                  const keys = Object.keys(data)
                  const msg = data[keys[0]]
                  this.$toasted.error(msg).goAway(1500)
                } else {
                  this.$toasted.error(err.response.message).goAway(1500)
                }
              }
            })
          }
        } else {
          this.$toasted.error(this.$t('messages.error.validationError')).goAway(1500)
        }
      })
    }
  }
}
</script>
